
<div ref="metadataTab">
  <panel-block v-if="selectedObjectModelRelation.can(ObjectModelRelationCapability.referenceable)" id="reference-name">
    <panel-item>
      <row>
        <column>
          <label :for="selectedObjectModelRelation.idForProp('reference_name')">Reference Name</label>
        </column>
        <suffix>
          <help-tooltip text="Use this value to refer to the relationship via API."></help-tooltip>
        </suffix>
      </row>
      <expandable-textarea
        :id="selectedObjectModelRelation.idForProp('reference_name')"
        :value="selectedObjectModelRelation.reference_name"
        disabled
        placeholder="Enter a reference name for APIs"></expandable-textarea>
    </panel-item>
  </panel-block>

  <panel-block v-if="selectedObjectModelRelation.can(ObjectModelRelationCapability.indexable)">
    <panel-item>
      <label :for="selectedObjectModelRelation.idForProp('indexable')">Index Relation</label>
      <yes-no-select
        v-model="selectedObjectModel.indexed_relation_client_ids"
        bind-by-array
        :val="selectedObjectModelRelation.client_id"
        :id="selectedObjectModelRelation.idForProp('indexable')"
        compress
      ></yes-no-select>
    </panel-item>
  </panel-block>
</div>
